export default __webpack_public_path__ + "static/media/transland-trucks-2.cc8e3d1b.png";